import { Injectable } from '@angular/core';
import { SelectDropDownComponent } from 'ngx-select-dropdown';

@Injectable({
    providedIn: 'root'
})

export class NGXSelectDropDownService {
    applySearchFocus(ngxSelectDropDown: SelectDropDownComponent): void {
        try {
            const inputElement = ngxSelectDropDown._elementRef.nativeElement.querySelector('input')
            if (inputElement) {
                inputElement.focus();
            }
        }
        catch (error) { }
    }
} 